<h2 matDialogTitle>
  Update Password
</h2>

<mat-dialog-content>
  <mgd-dialog-content-container>
    <form [formGroup]="updatePasswordForm" mgdEnhancedForm [disableWhileProcessing]="false" #mgdEnhancedForm="mgdEnhancedForm">
      <mat-form-field id="mat-current-password-field">
        <mat-label>Current Password</mat-label>
        <input matInput type="password" formControlName="currentPassword"
              mgdClearInput mgdEnhancedControl #currentPasswordControl="mgdEnhancedControl" />
        <mgd-clear-button matSuffix [formField]="currentPasswordControl" />
        <mat-error>
          <mgd-error-message [formField]="currentPasswordControl" />
        </mat-error>
      </mat-form-field>

      <mgd-set-password formControlName="newPassword" #newPasswordControl="mgdEnhancedControl" />
    </form>
  </mgd-dialog-content-container>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button mgdDialogCloseButton type="button">
    Cancel
  </button>

  <button mat-raised-button mgdButton mgdButtonType="save" [enhancedForm]="mgdEnhancedForm" type="button" (click)="onSubmitClick()">
    Update Password
  </button>
</mat-dialog-actions>
